// Backend error response shapes vary across this platform's services — some
// return { error }, some { detail }, the Arbiter/user services observed in
// production return { error_code, error_message, path }. Check known
// variants in order rather than assuming one shape, so real backend messages
// surface instead of always falling back to a generic message.
export const extractApiErrorMessage = (error, fallback) =>
  error?.data?.error_message ||
  error?.data?.error ||
  error?.data?.detail ||
  error?.data?.message ||
  fallback;
